"use strict";Object.defineProperty(exports, "__esModule", {value: true});




const OVERVIEW = { name: 'overview', label: 'Overview' }
const PEOPLE = { name: 'people', label: 'People' }
const SETTINGS = { name: 'settings', label: 'Settings' }
const PLAN = { name: 'plan', label: 'Plan' }
const API_KEYS = { name: 'api-keys', label: 'API keys & integrations' }
const REPORTS = { name: 'reports', label: 'Reports' }
const AUDIT = { name: 'audit', label: 'Audit' }

// A one-org account opens on its plan and has no Overview until a second
// org is added (screen 15, view A). Reports shows when the default org has
// REPORTS (master D-87, D-88). Audit comes last, in an account that records
// the audit log.
 const getAccountTabs = (account, hasReports = false) => [
  ...account.OrgKeys.length > 1
    ? [OVERVIEW, PEOPLE, SETTINGS, PLAN, API_KEYS]
    : [PLAN, PEOPLE, SETTINGS, API_KEYS],
  ...hasReports ? [REPORTS] : [],
  ...account.AuditLog ? [AUDIT] : [],
]; exports.getAccountTabs = getAccountTabs
